<template>
  <div :class="['emd-form-group', `js${name}group`]">
    <div class="emd-form-group">
      <label class="emd-label">{{ title }}</label>
      <div class="emd-chunk">
        <label v-for="(item, index) in items.enum" :key="index" class="emd-checkbox emd-control_checkbox" :for="item">
          {{ item }}
          <input class="emd-checkbox__input" type="checkbox" :id="item" :name="item" :checked="false" />
          <div class="emd-checkbox__area"></div>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EmdMultipleSelect',
  props: {
    name: String,
    title: String,
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    items: {
      type: [Array, Object],
      default: function () {
        return []
      }
    }
  }
}
</script>
